/*
 * Copyright (c) 2020. FINN Sp. z o.o.
 */

package pl.finn.forms.ezw

import io.kvision.navigo.Navigo
import io.kvision.routing.Routing
import pl.finn.forms.App
import pl.finn.forms.utils.stringProperty

fun Routing.ezwRouting(app: App): Navigo {
  return on("/elektroniczne_zawiadomienie_wierzyciela_ezw_nowy/:token", { params ->
    Model.nowy(stringProperty(params, "token"), app)
  }).on("/elektroniczne_zawiadomienie_wierzyciela_ezw_edycja/:token", { params ->
    Model.edycja(stringProperty(params, "token"), app)
  })
}
